<template>
    <div id="tryout-review">
        <v-card elevation="0" class="my-3">
            <!-- Tryout Items -->
            <v-list-item>
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Kode Tryout
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ $store.state.tryout.code }}
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item style="background-color: #fbfbfb">
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Nama Tryout
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ $store.state.tryout.name }}
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Jenis Tryout
                </v-list-item-title>
                <v-list-item-subtitle v-if="$store.state.tryout.is_repeated">
                    INSTANT
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else> BERJANGKA </v-list-item-subtitle>
            </v-list-item>
            <v-list-item style="background-color: #fbfbfb">
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Jenjang Tryout
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ $store.state.tryout.level }} /
                    {{ $store.state.tryout.type }}
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Durasi
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ $store.state.tryout.duration }} menit
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item style="background-color: #fbfbfb">
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Opsi
                </v-list-item-title>
                <v-list-item-subtitle v-if="$store.state.tryout.is_free_access">
                    Akses Gratis
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="$store.state.tryout.is_repeated">
                    Tryout Berulang
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Mulai
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ $store.state.tryout.start_date.value }}
                    {{ $store.state.tryout.start_time.value }}
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item style="background-color: #fbfbfb">
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Berakhir
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ $store.state.tryout.end_date.value }}
                    {{ $store.state.tryout.end_time.value }}
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item style="background-color: #fbfbfb">
                <v-list-item-title class="text-subtitle-2 font-weight-bold">
                    Status Tryout
                </v-list-item-title>
                <v-list-item-subtitle>
                    <v-btn
                        v-if="$store.state.tryout.status == 'DRAFT'"
                        elevation="0"
                        small
                        color="#F5F7FA"
                        class="dark--text"
                    >
                        Draft
                    </v-btn>
                    <v-btn
                        v-if="$store.state.tryout.status == 'REVIEW'"
                        elevation="0"
                        small
                        color="backgroundYellow"
                        class="darkYellow--text"
                    >
                        Review
                    </v-btn>
                    <v-btn
                        v-if="$store.state.tryout.status == 'PUBLISHED'"
                        elevation="0"
                        small
                        color="backgroundGreen"
                        class="darkGreen--text"
                    >
                        Publish
                    </v-btn>
                </v-list-item-subtitle>
            </v-list-item>
            <v-card outlined class="pa-0 mt-3 ma-0">
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    Subtest
                </v-card-title>
                <v-divider></v-divider>
                <!-- Tryout Subtest List -->
                <v-card-text class="px-0 pt-0 pb-2 ma-0">
                    <v-card
                        class="my-2"
                        flat
                        v-for="(subtest, index) in $store.state.tryout.subtests"
                        v-bind:key="subtest.id"
                    >
                        <v-list class="pa-2">
                            <template>
                                <v-list-item two-line>
                                    <span
                                        class="roboto-text font-weight-bold mt-3"
                                        style="
                                            top: 0 !important;
                                            position: absolute;
                                        "
                                        >{{ index + 1 }}. &nbsp; &nbsp;
                                    </span>
                                    <v-list-item-avatar class="mx-2 my-0">
                                        <v-img
                                            :src="subtest.subject_picture"
                                            width="45px"
                                        />
                                    </v-list-item-avatar>
                                    <v-list-item-content class="pa-0">
                                        <v-list-item-title
                                            class="font-weight-bold"
                                        >
                                            {{ subtest.subject_name }}
                                            <v-badge
                                                class="mx-2"
                                                color="#ECEFF5"
                                            >
                                                <template v-slot:badge>
                                                    <span
                                                        class="darkFade--text"
                                                    >
                                                        {{ subtest.duration }}m
                                                    </span>
                                                </template>
                                            </v-badge>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            {{ subtest.details.length }} Soal
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-card>
                </v-card-text>
            </v-card>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="$emit('uncompleted')" depressed text>
                    Kembali
                </v-btn>

                <v-btn
                    color="blew"
                    type="button"
                    class="btn btn-success pull-right"
                    @click="$emit('completed')"
                    depressed
                    dark
                >
                    Selesai
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm.function == 'DRAFT'"
                        color="blew"
                        text
                        @click="confirmDraft"
                    >
                        OK
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm.function == 'REVIEW'"
                        color="blew"
                        text
                        @click="confirmReview"
                    >
                        OK
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm.function == 'PUBLISH'"
                        color="blew"
                        text
                        @click="confirmPublish"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "tryout-review",

    components: {
        "app-spinner": Spinner,
    },

    props: {
        statusReview: { type: String, default: "DRAFT" },
    },

    data: function () {
        return {
            isLoading: false,
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
        };
    },

    watch: {
        statusReview: function (val) {
            if (val == "DRAFT" && this.$store.state.tryout.status != val) {
                this.dialogConfirm.function = "DRAFT";
                this.dialogConfirm.title =
                    "Apakah anda yakin untuk mengubah status Tryout ini menjadi 'DRAFT' ?";
                this.dialogConfirm.open = true;
            }

            if (val == "REVIEW" && this.$store.state.tryout.status != val) {
                this.dialogConfirm.function = "REVIEW";
                this.dialogConfirm.title =
                    "Apakah anda yakin untuk mengubah status Tryout ini menjadi 'REVIEW' ?";
                this.dialogConfirm.open = true;
            }

            if (val == "PUBLISH" && this.$store.state.tryout.status != val) {
                this.dialogConfirm.function = "PUBLISH";
                this.dialogConfirm.title =
                    "Apakah anda yakin untuk mengubah status Tryout ini menjadi 'PUBLISH' ?";
                this.dialogConfirm.open = true;
            }

            setTimeout(() => {
                this.$emit("statusReview", this.$store.state.tryout.status);
            }, 100);
        },
    },

    computed: {
        isDraft: function () {
            return this.$store.state.tryout.status == "DRAFT";
        },

        isReviewed: function () {
            return this.$store.state.tryout.status == "REVIEW";
        },
    },

    methods: {
        confirmReview: function () {
            this.isLoading = true;
            var context = this;
            var id = this.$store.state.tryout.id;

            TryoutService.reviewTryout(id, function (result) {
                context.isLoading = false;
                if (result.success) {
                    result.data.end_date = {
                        value: result.data.end_date,
                        option: false,
                    };
                    result.data.start_date = {
                        value: result.data.start_date,
                        option: false,
                    };
                    context.$store.commit("tryout_init", result.data);
                    context.dialogConfirm.open = false;
                    context.$emit("statusReview", result.data.status);
                }
            });
        },

        confirmPublish: function () {
            this.isLoading = true;
            var context = this;
            var id = this.$store.state.tryout.id;

            TryoutService.publishTryout(id, function (result) {
                context.isLoading = false;
                if (result.success) {
                    result.data.end_date = {
                        value: result.data.end_date,
                        option: false,
                    };
                    result.data.start_date = {
                        value: result.data.start_date,
                        option: false,
                    };
                    context.$store.commit("tryout_init", result.data);
                    context.dialogConfirm.open = false;
                    context.$emit("statusReview", result.data.status);
                }
            });
        },

        confirmDraft: function () {
            this.isLoading = true;
            var context = this;
            var id = this.$store.state.tryout.id;

            TryoutService.draftTryout(id, function (result) {
                context.isLoading = false;
                if (result.success) {
                    result.data.end_date = {
                        value: result.data.end_date,
                        option: false,
                    };
                    result.data.start_date = {
                        value: result.data.start_date,
                        option: false,
                    };
                    context.$store.commit("tryout_init", result.data);
                    context.dialogConfirm.open = false;
                    context.$emit("statusReview", result.data.status);
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Review.vue?54e30ef3